import Base from './Base';
import Phone from './Phone';
import { TYPES_INBOX } from '../modules/user';

export default class GroupInbox extends Base {
    constructor(item) {
        super(item);

        this.number = new Phone({});
    }

    get key() {
        if (this.is_favorite) {
            return 'onFavorite';
        }

        return 'group';
    }

    get inboxId() {
        return this.id;
    }

    get inboxType() {
        return TYPES_INBOX.GROUP;
    }

    get isGroupInbox() {
        return this.inboxType === TYPES_INBOX.GROUP;
    }

    get isUnifiedInbox() {
        return this.inboxType === TYPES_INBOX.UNIFIED;
    }

    get isSmartInbox() {
        return this.inboxType === TYPES_INBOX.SMART;
    }

    get isSharedInbox() {
        return this.inboxType === TYPES_INBOX.SHARED;
    }

    get teamsIds() {
        return this.teams.map(item => item.id);
    }
}
